// extracted by mini-css-extract-plugin
module.exports = {"root":"DnsTrackerPage-module__root__8gLX6","item":"DnsTrackerPage-module__item__2iRgR"};